var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShowAsList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#2F1F19",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M6.616 8.5H4.384A1.884 1.884 0 0 1 2.5 6.616V4.384c0-1.04.843-1.884 1.884-1.884h2.232c1.04 0 1.884.843 1.884 1.884v2.232c0 1.04-.843 1.884-1.884 1.884m9 0h-2.232A1.884 1.884 0 0 1 11.5 6.616V4.384c0-1.04.843-1.884 1.884-1.884h2.232c1.04 0 1.884.843 1.884 1.884v2.232c0 1.04-.843 1.884-1.884 1.884m-9 9H4.384A1.884 1.884 0 0 1 2.5 15.616v-2.232c0-1.04.843-1.884 1.884-1.884h2.232c1.04 0 1.884.843 1.884 1.884v2.232c0 1.04-.843 1.884-1.884 1.884m9 0h-2.232a1.884 1.884 0 0 1-1.884-1.884v-2.232c0-1.04.843-1.884 1.884-1.884h2.232c1.04 0 1.884.843 1.884 1.884v2.232c0 1.04-.843 1.884-1.884 1.884",
  clipRule: "evenodd"
})));
export default SvgShowAsList;